export default class talkToUsCtrl {
    constructor($scope, $http, $rootScope, $compile) {
        'ngInject';

        $scope.validationOptions = {
            rules: {
                talk_email: {
                    required: true,
                    email: true
                }
            },
            messages: {
                talk_email: {
                    required: "We need your email address to contact you",
                    email: "Your email address must be in the format of name@domain.com"
                }
            },
            ignore: [],
            errorPlacement: function (error, element) {
                error.insertAfter(element);
            },
            highlight: function (element, errorClass, validClass) {
                if ($(element).is(":hidden")) {
                    $(element)
                        .addClass(errorClass)
                        .removeClass(validClass);
                } else {
                    $(element)
                        .addClass(errorClass)
                        .removeClass(validClass);
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if ($(element).is(":hidden")) {
                    $(element)
                        .removeClass(errorClass)
                        .addClass(validClass);
                } else {
                    $(element)
                        .removeClass(errorClass)
                        .addClass(validClass);
                }
            }
        };

        $scope.is_sent = false;
        $scope.form = {
            "fullname": "",
            "phone": "",
            "email": "",
            "subject": "",
            "message": ""
        };
        $scope.form._token = window.Laravel.csrfToken;
        $scope.messageSent = false;
        $scope.sending = false;
        $scope.submitForm = function (e) {
            $scope.sending = true;
            e.preventDefault();
            $http({
                method: "POST",
                url: "/en/contact/send",
                data: $rootScope.params($scope.form),
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                } // set the headers so angular passing info as form data (not request payload)
            }).then(function (data) {
                console.log(data);

                $scope.form = {
                    "fullname": "",
                    "phone": "",
                    "email": "",
                    "subject": "",
                    "message": ""
                };
                $scope.is_sent = true;
                $scope.sending = false;
            });

        };
    }
}